import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { CloseOutlined, DownOutlined } from '@ant-design/icons';
import { useIntl } from '@ant-design/pro-provider';
import { ConfigProvider } from 'antd';
import classNames from 'classnames';
import React, { useContext, useImperativeHandle, useRef } from 'react';
import { useStyle } from './style';

var FieldLabelFunction = function FieldLabelFunction(props, ref) {
  var _classNames;

  var label = props.label,
      onClear = props.onClear,
      value = props.value,
      _props$size = props.size,
      size = _props$size === void 0 ? 'middle' : _props$size,
      disabled = props.disabled,
      onLabelClick = props.onLabelClick,
      ellipsis = props.ellipsis,
      placeholder = props.placeholder,
      className = props.className,
      formatter = props.formatter,
      bordered = props.bordered,
      _props$allowClear = props.allowClear,
      allowClear = _props$allowClear === void 0 ? true : _props$allowClear;

  var _useContext = useContext(ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var prefixCls = getPrefixCls('pro-core-field-label');

  var _useStyle = useStyle(prefixCls),
      wrapSSR = _useStyle.wrapSSR,
      hashId = _useStyle.hashId;

  var intl = useIntl();
  var clearRef = useRef(null);
  var labelRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      labelRef: labelRef,
      clearRef: clearRef
    };
  });

  var formatterText = function formatterText(aValue) {
    if (formatter) {
      return formatter(aValue);
    }

    return Array.isArray(aValue) ? aValue.join(',') : aValue;
  };

  var getTextByValue = function getTextByValue(aLabel, aValue) {
    if (aValue !== undefined && aValue !== null && aValue !== '' && (!Array.isArray(aValue) || aValue.length)) {
      var _str$toString, _str$toString$substr;

      var prefix = aLabel ? _jsxs("span", {
        onClick: onLabelClick,
        className: "".concat(prefixCls, "-text"),
        children: [aLabel, ': ']
      }) : '';
      var str = formatterText(aValue);

      if (!ellipsis) {
        return _jsxs("span", {
          style: {
            display: 'inline-flex',
            alignItems: 'center'
          },
          children: [prefix, formatterText(aValue)]
        });
      } // 普通表单值最大长度41，如2022-06-21 20:11:25 ~ 2022-06-22 20:11:25


      var VALUE_MAX_LENGTH = 41;

      var getText = function getText() {
        var isArrayValue = Array.isArray(aValue) && aValue.length > 1;
        var unitText = intl.getMessage('form.lightFilter.itemUnit', '项');

        if (typeof str === 'string' && str.length > VALUE_MAX_LENGTH && isArrayValue) {
          return "...".concat(aValue.length).concat(unitText);
        }

        return '';
      };

      var tail = getText();
      return _jsxs("span", {
        title: typeof str === 'string' ? str : undefined,
        style: {
          display: 'inline-flex',
          alignItems: 'center'
        },
        children: [prefix, _jsx("span", {
          style: {
            paddingInlineStart: 4
          },
          children: typeof str === 'string' ? str === null || str === void 0 ? void 0 : (_str$toString = str.toString()) === null || _str$toString === void 0 ? void 0 : (_str$toString$substr = _str$toString.substr) === null || _str$toString$substr === void 0 ? void 0 : _str$toString$substr.call(_str$toString, 0, VALUE_MAX_LENGTH) : str
        }), tail]
      });
    }

    return aLabel || placeholder;
  };

  return wrapSSR(_jsxs("span", {
    className: classNames(prefixCls, hashId, "".concat(prefixCls, "-").concat(size), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), !!value || value === 0), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-allow-clear"), allowClear), _classNames), className),
    ref: labelRef,
    children: [getTextByValue(label, value), (value || value === 0) && allowClear && _jsx(CloseOutlined, {
      role: "button",
      title: "\u6E05\u9664",
      className: classNames("".concat(prefixCls, "-icon"), hashId, "".concat(prefixCls, "-close")),
      onClick: function onClick(e) {
        if (onClear && !disabled) {
          onClear();
        }

        e.stopPropagation();
      },
      ref: clearRef
    }), _jsx(DownOutlined, {
      className: classNames("".concat(prefixCls, "-icon"), "".concat(prefixCls, "-arrow"))
    })]
  }));
};

export var FieldLabel = /*#__PURE__*/React.forwardRef(FieldLabelFunction);